import { render } from "./DataApiMode.vue?vue&type=template&id=7e8f9b4e&scoped=true"
import script from "./DataApiMode.vue?vue&type=script&lang=js"
export * from "./DataApiMode.vue?vue&type=script&lang=js"

import "./DataApiMode.vue?vue&type=style&index=0&id=7e8f9b4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e8f9b4e"]])

export default __exports__